import React from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { IGroupsTree } from '../../../store/modules/facility/i-facility';
import SecondaryButton from '../../lib/secondary-button';

interface IFacilityTableProps {
  data: IGroupsTree[];
}

const FacilityTable: React.FC<IFacilityTableProps> = ({ data }) => {
  const { location } = useHistory();

  const sortedData = Array.isArray(data)
    ? [...data].sort((a, b) => a.name.localeCompare(b.name))
    : [];

  const columns: TableProps<IGroupsTree>['columns'] = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <div>
          <Link to={`${location.pathname}/${record.id}`}>
            <SecondaryButton
              className="left"
            >
              Open
            </SecondaryButton>
          </Link>
          <Link to={`${location.pathname}/editGroup?group=${record?.id || 'root'}&groupType=${record?.groupType_id ?? 'root'}`}>
            <SecondaryButton>
              Edit
            </SecondaryButton>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <Table<IGroupsTree> rowKey="id" columns={columns} dataSource={sortedData} pagination={false} />
  );
};

export default FacilityTable;
